<template>
  <div class="w-full">
    <div class="w-full text-xs">
    </div>
      <div v-if="iframeSrc">
    <div
      id="fuera"
      class="container fluid mt-0"
      style="height: 100%; display: block;"
    >
      <iframe
        :src="iframeSrc"
         v-resize="{ log: true }"
        style="min-width: 100%; border: none;"
        frameborder="no"
        width="100%"
        scrolling="no"
        id="iFrameResizer2"
      >Su navegador no soporta IFRAMES. Inténtelo con otro distinto.</iframe>
    </div>
      </div>  
  </div>   
</template>
<script>
import FormularioAltas from '@/components/FormularioAltas'
import CabeceraWeb from "@/components/Cabecera"
export default {
  props: ['iframeSrc']
}
</script>
<style>
iframe {
  width: 1px;
  min-width: 100%;
  height: 2400px;
}
  
</style>